import { Box, Container, CssBaseline, Grid, Paper } from "@mui/material";
import { Outlet } from "react-router-dom";

const NotFoundLayout = () => {
  return (
    <Box className="container-not-found">
      <Outlet />
      <Box component="footer" className="footer">
        Copyright © {new Date().getFullYear()} Avanse Financial Services Ltd.
        All Rights Reserved .
      </Box>
    </Box>
  );
};

export default NotFoundLayout;
